"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListViewerComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
const ClipboardService_1 = __importStar(require("../../services/ClipboardService"));
//@ts-ignore                
let rwsTemplate = T.html `<div class="list-viewer">
    ${T.when(x => x.loading, T.html `
    <div class="list-viewer__loading">
        <div class="spinner"></div>
        Loading list...
    </div>
    `)}

    ${T.when(x => x.error, T.html `
    <div class="list-viewer__error">
        <i class="fas fa-exclamation-triangle"></i>
        ${x => x.error}
    </div>
    `)}

    
    <slot name="header"></slot>

    <div class="list-wrapper">       
        ${T.when(x => x.listType === 'ordered', T.html `
        <ol class="${x => x.computedListClass}" @click="${x => x.handleListClick}">
            <slot name="items" ${T.slotted('slottedNodes')}></slot>
            ${T.when(x => x.shouldShowProgrammaticItems, T.html `
                ${T.repeat(x => x.items, T.html `
                <li class="${(x, c) => c.parent.computedItemClass}">
                    ${x => x}
                </li>
                `)}
            `)}
        </ol>
        `)}

        ${T.when(x => x.listType === 'unordered', T.html `
        <ul class="${x => x.computedListClass}" @click="${x => x.handleListClick}">
            <slot name="items" ${T.slotted('slottedNodes')}></slot>
            ${T.when(x => x.shouldShowProgrammaticItems, T.html `
                ${T.repeat(x => x.items, T.html `
                <li class="${(x, c) => c.parent.computedItemClass}"
                    >
                    ${x => x}
                </li>
                `)}
            `)}
        </ul>
        `)}
    </div>

    
    <slot name="footer"></slot>
</div>`;
require("./styles/layout.scss");
const styles = T.css `:host {
  display: block;
  width: 100%;
}

.list-viewer {
  font-family: inherit;
}
.list-viewer__loading {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
  color: var(--text-secondary, #666);
}
.list-viewer__loading .spinner {
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
.list-viewer__error {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
  color: var(--error-color, #dc3545);
  background: var(--error-bg, #f8d7da);
  border-radius: 4px;
  margin-bottom: 16px;
}
.list-viewer__empty {
  text-align: center;
  padding: 32px 16px;
  color: var(--text-secondary, #666);
}
.list-viewer__empty i {
  font-size: 24px;
  margin-bottom: 8px;
  display: block;
}
.list-viewer__empty p {
  margin: 0;
}

.list-wrapper .list-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.list-wrapper .list-actions .list-type-label {
  font-size: 0.875rem;
  color: var(--text-secondary, #666);
  font-weight: 500;
}
.list-wrapper .list-actions .copy-button {
  background: none;
  border: 1px solid var(--border-color, #ddd);
  border-radius: 4px;
  padding: 6px 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: var(--text-primary, #333);
}
.list-wrapper .list-actions .copy-button:hover {
  background: var(--hover-bg, #f5f5f5);
}
.list-wrapper .list-actions .copy-button.is-copied {
  color: var(--success-color, #28a745);
  border-color: var(--success-color, #28a745);
}
.list-wrapper .list-actions .copy-button i {
  font-size: 14px;
}
.list-wrapper ol, .list-wrapper ul {
  margin: 0;
  padding-left: 20px;
}
.list-wrapper ol.items__list, .list-wrapper ul.items__list {
  list-style-type: disc;
}
.list-wrapper ol.items__list.steps, .list-wrapper ul.items__list.steps {
  list-style-type: decimal;
}
.list-wrapper ol li, .list-wrapper ul li {
  margin-bottom: 8px;
  line-height: 1.5;
  cursor: pointer;
  transition: background-color 0.2s ease;
  padding: 4px 8px;
  border-radius: 4px;
}
.list-wrapper ol li:hover, .list-wrapper ul li:hover {
  background: var(--hover-bg, rgba(0, 0, 0, 0.05));
}
.list-wrapper ol li.items__listItem, .list-wrapper ul li.items__listItem {
  position: relative;
}
.list-wrapper ol li.items__listItem--step, .list-wrapper ul li.items__listItem--step {
  font-weight: 500;
}
.list-wrapper ol li[slot=items], .list-wrapper ul li[slot=items] {
  display: list-item;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (prefers-color-scheme: dark) {
  .list-viewer__loading {
    color: var(--text-secondary-dark, #aaa);
  }
  .list-viewer__error {
    color: var(--error-color-dark, #f5c6cb);
    background: var(--error-bg-dark, #721c24);
  }
  .list-viewer__empty {
    color: var(--text-secondary-dark, #aaa);
  }
  .list-wrapper .list-actions .list-type-label {
    color: var(--text-secondary-dark, #aaa);
  }
  .list-wrapper .list-actions .copy-button {
    border-color: var(--border-color-dark, #555);
    color: var(--text-primary-dark, #fff);
  }
  .list-wrapper .list-actions .copy-button:hover {
    background: var(--hover-bg-dark, rgba(255, 255, 255, 0.1));
  }
  .list-wrapper ol li:hover, .list-wrapper ul li:hover {
    background: var(--hover-bg-dark, rgba(255, 255, 255, 0.1));
  }
}`;
const shadowOptions = { "mode": "open" };
let ListViewerComponent = class ListViewerComponent extends client_1.RWSViewComponent {
    // Attribute change handlers
    listTypeChanged(oldValue, newValue) {
        // Update computed properties when listType changes
        this.updateComputedProperties();
        // If listType changed and we have slotted content, we might need to refresh
        if (oldValue && oldValue !== newValue && this.slottedNodes.length > 0) {
            this.slottedNodesChanged();
        }
    }
    listClassChanged() {
        this.updateComputedListClass();
    }
    itemClassChanged() {
        this.updateComputedItemClass();
    }
    slottedNodesChanged() {
        // Update computed properties first
        this.updateHasSlottedItems();
        this.updateShouldShowProgrammaticItems();
        // Update items array when slotted nodes change
        if (this.slottedNodes && this.slottedNodes.length > 0) {
            // Filter only li elements from slotted nodes
            const liElements = this.slottedNodes.filter(node => node.nodeType === Node.ELEMENT_NODE &&
                node.tagName.toLowerCase() === 'li');
            // If we have slotted li elements, don't override with items array
            // The slotted content should take precedence
            if (liElements.length > 0) {
                // Clear programmatic items when slotted content is present
                this.items = [];
            }
            else {
                // Fallback: extract text content for display purposes
                this.items = this.slottedNodes.map(node => { var _a; return ((_a = node.textContent) === null || _a === void 0 ? void 0 : _a.trim()) || ''; }).filter(text => text.length > 0);
            }
        }
        // Update computed properties after items change
        this.updateShouldShowProgrammaticItems();
    }
    constructor(clipboardService) {
        super();
        this.clipboardService = clipboardService;
        this.listType = 'unordered';
        this.listClass = '';
        this.itemClass = '';
        this.items = [];
        this.loading = false;
        this.error = null;
        this.slottedNodes = [];
        this.computedListClass = '';
        this.computedItemClass = '';
        this.listTag = 'ul';
        this.hasSlottedItems = false;
        this.shouldShowProgrammaticItems = false;
        this.updateComputedProperties();
    }
    // Update all computed properties
    updateComputedProperties() {
        this.updateComputedListClass();
        this.updateComputedItemClass();
        this.updateListTag();
        this.updateHasSlottedItems();
        this.updateShouldShowProgrammaticItems();
    }
    updateComputedListClass() {
        if (this.listClass) {
            this.computedListClass = this.listClass;
        }
        else {
            this.computedListClass = this.listType === 'ordered' ? 'items__list steps' : 'items__list';
        }
    }
    updateComputedItemClass() {
        if (this.itemClass) {
            this.computedItemClass = this.itemClass;
        }
        else {
            this.computedItemClass = this.listType === 'ordered' ? 'items__listItem--step' : 'items__listItem';
        }
    }
    updateListTag() {
        this.listTag = this.listType === 'ordered' ? 'ol' : 'ul';
    }
    updateHasSlottedItems() {
        this.hasSlottedItems = this.slottedNodes && this.slottedNodes.filter(node => node.nodeType === Node.ELEMENT_NODE &&
            node.tagName.toLowerCase() === 'li').length > 0;
    }
    updateShouldShowProgrammaticItems() {
        this.shouldShowProgrammaticItems = !this.hasSlottedItems && this.items && this.items.length > 0;
    }
    // Parse markdown-style list from text
    parseListFromText(text) {
        if (!text) {
            this.items = [];
            this.updateShouldShowProgrammaticItems();
            return;
        }
        // Split by lines and filter out empty lines
        const lines = text.split('\n').filter(line => line.trim());
        const listItems = [];
        for (const line of lines) {
            // Match numbered lists (1. 2. etc.) or bulleted lists (- * +)
            const match = line.match(/^\s*(?:\d+\.|\-|\*|\+)\s(.+)/);
            if (match) {
                listItems.push(match[1].trim());
                // Auto-detect list type from first item
                if (listItems.length === 1) {
                    this.listType = /^\s*\d+\./.test(line) ? 'ordered' : 'unordered';
                }
            }
        }
        this.items = listItems;
        this.updateComputedProperties();
    }
    // Set items directly
    setItems(items) {
        this.items = [...items];
        this.updateShouldShowProgrammaticItems();
    }
    // Add a single item
    addItem(item) {
        this.items = [...this.items, item];
        this.updateShouldShowProgrammaticItems();
    }
    // Remove item by index
    removeItem(index) {
        if (index >= 0 && index < this.items.length) {
            const newItems = [...this.items];
            newItems.splice(index, 1);
            this.items = newItems;
            this.updateShouldShowProgrammaticItems();
        }
    }
    // Clear all items
    clearItems() {
        this.items = [];
        this.updateShouldShowProgrammaticItems();
    }
    // Refresh the component state
    refresh() {
        var _a;
        // Re-process slotted nodes
        if (this.slottedNodes.length > 0) {
            this.slottedNodesChanged();
        }
        // Re-check for any text content only if no slotted items
        if (!this.hasSlottedItems) {
            const slotContent = (_a = this.textContent) === null || _a === void 0 ? void 0 : _a.trim();
            if (slotContent && this.items.length === 0) {
                this.parseListFromText(slotContent);
            }
        }
        // Update all computed properties
        this.updateComputedProperties();
    }
    // Event handlers
    handleItemClick(index, event) {
        // Get the actual clicked element
        const target = event.target;
        const liElement = target.closest('li');
        // If we have slotted nodes, use the actual slotted element
        let item;
        if (this.hasSlottedItems) {
            const liElements = this.slottedNodes.filter(node => node.nodeType === Node.ELEMENT_NODE &&
                node.tagName.toLowerCase() === 'li');
            item = liElements[index] || this.items[index];
        }
        else {
            item = this.items[index];
        }
        const customEvent = new CustomEvent('list:item:click', {
            detail: {
                index,
                item: item,
                element: liElement,
                originalEvent: event
            },
            bubbles: true,
            composed: true
        });
        this.dispatchEvent(customEvent);
    }
    // Lifecycle methods
    connectedCallback() {
        var _a;
        super.connectedCallback();
        // Handle potential duplicate attributes (like in your example with both list-type and listtype)
        const listTypeAttr = this.getAttribute('list-type');
        const listTypeAttrAlt = this.getAttribute('listtype');
        if (listTypeAttr && listTypeAttrAlt && listTypeAttr !== listTypeAttrAlt) {
            // Prefer list-type over listtype if both are present but different
            this.listType = listTypeAttr;
        }
        else if (listTypeAttrAlt && !listTypeAttr) {
            // If only listtype is present, use it
            this.listType = listTypeAttrAlt;
        }
        // Update computed properties after attributes are resolved
        this.updateComputedProperties();
        // Auto-parse from slot content if no items are set and no slotted items
        if (this.items.length === 0 && !this.hasSlottedItems) {
            const slotContent = (_a = this.textContent) === null || _a === void 0 ? void 0 : _a.trim();
            if (slotContent) {
                this.parseListFromText(slotContent);
            }
        }
    }
};
exports.ListViewerComponent = ListViewerComponent;
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], ListViewerComponent.prototype, "listType", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], ListViewerComponent.prototype, "listClass", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], ListViewerComponent.prototype, "itemClass", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ListViewerComponent.prototype, "items", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ListViewerComponent.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], ListViewerComponent.prototype, "error", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ListViewerComponent.prototype, "slottedNodes", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], ListViewerComponent.prototype, "computedListClass", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], ListViewerComponent.prototype, "computedItemClass", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], ListViewerComponent.prototype, "listTag", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ListViewerComponent.prototype, "hasSlottedItems", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ListViewerComponent.prototype, "shouldShowProgrammaticItems", void 0);
exports.ListViewerComponent = ListViewerComponent = __decorate([
    (0, client_1.RWSView)('list-viewer', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(ClipboardService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof ClipboardService_1.ClipboardServiceInstance !== "undefined" && ClipboardService_1.ClipboardServiceInstance) === "function" ? _a : Object])
], ListViewerComponent);
ListViewerComponent.defineComponent();
